export default "__VITE_ASSET__CnDVzWH3__"